import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  containerNumber: Yup.string()
    .required('Container number is required')
    .matches(/^[A-Z]{4}\d{7}$/, 'Invalid container number format (e.g., ABCD1234567)'),
    
  liner: Yup.string()
    .required('Liner is required'),
    
  yardLocation: Yup.string()
    .required('Yard location is required'),
    
  bookingDateandTime: Yup.date()
    .required('Booking date and time is required')
    .typeError('Invalid date format'),
    
  containerCheckList: Yup.array()
    .of(Yup.object().shape({})) // You can define the shape of each checklist item if known
    .required('Container checklist is required')
    .min(1, 'At least one checklist item is required'),
});
